<template>
  <div>
    <Header></Header>
    <div class="article_list">
      <ul>
        <li v-for="i in list" v-bind:key="i.id">
          <router-link :to="'/partyTraining/content/' + i.id" class="article_title">
            {{ i.name }}
          </router-link>
          <i v-text="$utils.uuid(8,16)"></i>
          <img v-bind:src="i.icon" alt="">
        </li>
      </ul>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>

import Header from '../../components/partyTraining/header.vue'
import Footer from '../../components/footer.vue'

export default {
  components: { Header, Footer },
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getInstrumentList()
  },
  methods: {
    getInstrumentList () {
      this.$api.post(this.$global.beatsApiPath, '/smph_beats/f/bt/btInstrument/search', null, r => {
        console.log($)
        this.list = r.data
        console.log(this.list)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/partyTraining/index.vue